import { Platform, StyleSheet } from 'react-native';
import colors from '../../lib/colors';

export const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: colors.bgWeak,
    },
    scrollView: {
        flex: 1,
    },
    content: {
        padding: 20,
        paddingBottom: 40,
        ...(Platform.OS === 'web' && {
            maxWidth: 1200,
            alignSelf: 'center',
            width: '100%',
        }),
    },
    backLink: {
        marginBottom: 24,
    },
    backLinkText: {
        fontSize: 16,
        color: colors.primaryGreen,
        fontWeight: '500',
    },
    title: {
        fontSize: 42,
        fontWeight: 'bold',
        color: colors.darkGreen,
        marginBottom: 28,
        textAlign: 'center',
    },
    titleWithSubtitle: {
        marginBottom: 12,
    },
    subtitle: {
        fontSize: 18,
        color: colors.text500,
        lineHeight: 28,
        marginBottom: 32,
        textAlign: 'center',
    },
    offerBanner: {
        alignSelf: 'center',
        width: '100%',
        maxWidth: 760,
        borderTopWidth: 1,
        borderBottomWidth: 1,
        borderColor: colors.primaryGreen,
        backgroundColor: '#f7fbf2',
        paddingVertical: 22,
        paddingHorizontal: 24,
        marginBottom: 28,
        alignItems: 'center',
    },
    offerEyebrow: {
        color: colors.primaryGreen,
        fontSize: 12,
        fontWeight: '700',
        letterSpacing: 0,
        marginBottom: 6,
    },
    offerTitle: {
        color: colors.darkGreen,
        fontSize: 28,
        lineHeight: 34,
        textAlign: 'center',
        marginBottom: 8,
    },
    offerDescription: {
        color: colors.text700,
        fontSize: 15,
        lineHeight: 22,
        textAlign: 'center',
        maxWidth: 620,
    },
    offerUnavailableNotice: {
        backgroundColor: '#fff7ed',
        borderColor: '#fed7aa',
    },
    toggleContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        alignSelf: 'center',
        gap: 12,
        paddingHorizontal: 20,
        paddingVertical: 10,
        borderRadius: 100,
        borderWidth: 1,
        borderColor: colors.border,
        backgroundColor: colors.card,
        marginBottom: 40,
    },
    toggleLabelContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 6,
    },
    toggleLabel: {
        fontSize: 15,
        color: colors.text500,
    },
    toggleLabelActive: {
        fontWeight: '600',
        color: '#1f2937',
    },
    saveBadge: {
        backgroundColor: '#4b5563',
        paddingHorizontal: 8,
        paddingVertical: 3,
        borderRadius: 6,
    },
    saveBadgeText: {
        fontSize: 11,
        fontWeight: '600',
        color: '#ffffff',
    },
    catalogNotice: {
        alignSelf: 'center',
        backgroundColor: colors.card,
        borderRadius: 12,
        borderWidth: 1,
        borderColor: colors.border,
        paddingVertical: 16,
        paddingHorizontal: 20,
        marginBottom: 24,
        maxWidth: 520,
    },
    catalogNoticeText: {
        color: colors.text700,
        fontSize: 15,
        textAlign: 'center',
        lineHeight: 22,
    },
    checkoutErrorNotice: {
        backgroundColor: '#fef2f2',
        borderColor: '#fecaca',
    },
    checkoutErrorText: {
        color: colors.errorRed,
    },
    subscriptionNotice: {
        maxWidth: 720,
        backgroundColor: '#f7fbf2',
        borderColor: '#cfe1c2',
    },
    subscriptionNoticeText: {
        color: colors.darkGreen,
    },
    subscriptionCanceledNotice: {
        backgroundColor: '#fff7ed',
        borderColor: '#fed7aa',
    },
    subscriptionCanceledNoticeText: {
        color: colors.cookieBarGray,
    },
    pricingGrid: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 20,
        marginBottom: 32,
        ...(Platform.OS === 'web' && {
            justifyContent: 'center',
        }),
    },
    pricingCard: {
        backgroundColor: colors.card,
        borderRadius: 12,
        borderWidth: 2,
        borderColor: colors.border,
        padding: 28,
        flex: 1,
        minWidth: 250,
        position: 'relative',
        flexDirection: 'column',
        ...(Platform.OS === 'web' && {
            boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
        }),
        ...(Platform.OS === 'ios' && {
            shadowColor: '#000',
            shadowOffset: { width: 0, height: 1 },
            shadowOpacity: 0.05,
            shadowRadius: 3,
        }),
        ...(Platform.OS === 'android' && {
            elevation: 2,
        }),
    },
    popularCard: {
        borderColor: colors.action,
        borderWidth: 3,
        ...(Platform.OS === 'web' && {
            boxShadow: '0 4px 12px rgba(234,88,12,0.15)',
        }),
    },
    currentPlanCard: {
        borderColor: colors.primaryGreen,
        borderWidth: 3,
        ...(Platform.OS === 'web' && {
            boxShadow: '0 4px 12px rgba(76,125,49,0.16)',
        }),
    },
    canceledPlanCard: {
        borderColor: '#f59e0b',
        ...(Platform.OS === 'web' && {
            boxShadow: '0 4px 12px rgba(245,158,11,0.14)',
        }),
    },
    popularBadge: {
        position: 'absolute',
        top: -12,
        left: '50%',
        transform: [{ translateX: -50 }],
        backgroundColor: colors.action,
        paddingHorizontal: 16,
        paddingVertical: 6,
        borderRadius: 12,
    },
    popularBadgeText: {
        color: 'white',
        fontSize: 11,
        fontWeight: '700',
        letterSpacing: 0.5,
    },
    currentPlanBadge: {
        backgroundColor: colors.primaryGreen,
    },
    canceledPlanBadge: {
        backgroundColor: '#f59e0b',
    },
    planTitle: {
        fontSize: 48,
        fontWeight: '700',
        color: colors.darkGreen,
        marginBottom: 14,
        marginTop: 8,
        lineHeight: 52,
    },
    planDescription: {
        fontSize: 15,
        color: colors.text500,
        marginBottom: 24,
        lineHeight: 22,
    },
    priceContainer: {
        flexDirection: 'row',
        alignItems: 'baseline',
        marginBottom: 8,
    },
    regularPrice: {
        color: colors.text500,
        fontSize: 14,
        lineHeight: 20,
        textDecorationLine: 'line-through',
        marginBottom: 4,
    },
    offerPrice: {
        color: colors.primaryGreen,
    },
    billingText: {
        fontSize: 13,
        color: colors.text500,
        marginBottom: 20,
    },
    price: {
        fontSize: 32,
        fontWeight: 'bold',
        color: colors.cookieBarGray,
        lineHeight: 36,
    },
    priceUnit: {
        fontSize: 16,
        color: colors.text500,
        marginLeft: 4,
    },
    featureList: {
        gap: 12,
    },
    featureItem: {
        flexDirection: 'row',
        alignItems: 'flex-start',
        gap: 10,
    },
    checkmark: {
        fontSize: 18,
        color: colors.primaryGreen,
        fontWeight: 'bold',
        marginTop: 2,
    },
    featureContent: {
        flex: 1,
    },
    featureLine: {
        flexDirection: 'row',
        alignItems: 'flex-start',
    },
    featureText: {
        fontSize: 15,
        color: colors.text700,
        lineHeight: 22,
        flex: 1,
        flexShrink: 1,
    },
    featureLink: {
        color: colors.primaryGreenDark,
        textDecorationLine: 'underline',
    },
    featureHelpButton: {
        width: 20,
        height: 20,
        flexShrink: 0,
        borderRadius: 10,
        alignItems: 'center',
        justifyContent: 'center',
        marginLeft: 5,
        marginTop: 2,
        ...(Platform.OS === 'web' && {
            cursor: 'pointer',
        }),
    },
    featureTooltip: {
        backgroundColor: '#f7fbf2',
        borderColor: '#cfe1c2',
        borderRadius: 10,
        borderWidth: 1,
        marginTop: 8,
        paddingHorizontal: 12,
        paddingVertical: 10,
    },
    featureTooltipText: {
        color: colors.text700,
        fontSize: 13,
        lineHeight: 19,
    },
    cardFooter: {
        marginTop: 'auto',
        paddingTop: 28,
        alignItems: 'center',
    },
    ctaButton: {
        backgroundColor: colors.cookieBarGray,
        paddingVertical: 14,
        paddingHorizontal: 24,
        borderRadius: 8,
        alignItems: 'center',
        alignSelf: 'center',
        maxWidth: 230,
        width: '100%',
        ...(Platform.OS === 'web' && {
            cursor: 'pointer',
            transition: 'opacity 0.2s',
            ':hover': {
                opacity: 0.9,
            },
        }),
    },
    ctaButtonDisabled: {
        opacity: 0.65,
    },
    ctaButtonText: {
        color: 'white',
        fontSize: 15,
        fontWeight: '600',
        textAlign: 'center',
    },
    disclaimer: {
        fontSize: 12,
        color: colors.text500,
        marginTop: 12,
        textAlign: 'center',
        lineHeight: 18,
    },
    currentPlanText: {
        color: colors.text700,
        fontSize: 13,
        lineHeight: 19,
        textAlign: 'center',
        marginBottom: 12,
    },
    secondaryBillingButton: {
        backgroundColor: colors.card,
        borderColor: colors.border,
        borderWidth: 1,
        paddingVertical: 10,
        paddingHorizontal: 16,
        borderRadius: 8,
        alignItems: 'center',
        alignSelf: 'center',
        maxWidth: 230,
        width: '100%',
        ...(Platform.OS === 'web' && {
            cursor: 'pointer',
            transition: 'background-color 0.2s, border-color 0.2s',
            ':hover': {
                backgroundColor: colors.bgWeak,
                borderColor: colors.mediumGray,
            },
        }),
    },
    secondaryBillingButtonText: {
        color: colors.text700,
        fontSize: 13,
        fontWeight: '600',
        textAlign: 'center',
    },
    footerDisclaimer: {
        fontSize: 13,
        color: colors.text500,
        textAlign: 'center',
        marginBottom: 40,
        lineHeight: 20,
    },
    slimCardsContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 16,
        marginBottom: 32,
        ...(Platform.OS === 'web' && {
            justifyContent: 'center',
        }),
    },
    slimCard: {
        backgroundColor: colors.card,
        borderRadius: 12,
        borderWidth: 1,
        borderColor: colors.border,
        padding: 24,
        flex: 1,
        minWidth: 280,
        ...(Platform.OS === 'web' && {
            boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
        }),
        ...(Platform.OS === 'ios' && {
            shadowColor: '#000',
            shadowOffset: { width: 0, height: 1 },
            shadowOpacity: 0.05,
            shadowRadius: 3,
        }),
        ...(Platform.OS === 'android' && {
            elevation: 2,
        }),
    },
    slimCardContent: {
        flexDirection: 'row',
        gap: 16,
    },
    slimIconBox: {
        width: 56,
        height: 56,
        borderRadius: 12,
        borderWidth: 1,
        borderColor: colors.border,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: colors.card,
    },
    slimCardRight: {
        flex: 1,
    },
    slimCardTitle: {
        fontSize: 20,
        fontWeight: '700',
        color: colors.darkGreen,
        marginBottom: 8,
    },
    slimCardSubtitle: {
        fontSize: 14,
        color: colors.text500,
        marginBottom: 16,
        lineHeight: 20,
    },
    slimFeatureGrid: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 10,
        marginBottom: 20,
    },
    slimFeatureItem: {
        flexDirection: 'row',
        alignItems: 'flex-start',
        gap: 6,
        width: '48%',
        minWidth: 140,
    },
    slimCheckmark: {
        fontSize: 14,
        color: colors.primaryGreen,
        fontWeight: 'bold',
        marginTop: 1,
    },
    slimFeatureText: {
        fontSize: 13,
        color: colors.text700,
        lineHeight: 18,
        flex: 1,
    },
    slimButton: {
        borderWidth: 1,
        borderColor: colors.border,
        backgroundColor: 'transparent',
        paddingVertical: 12,
        paddingHorizontal: 20,
        borderRadius: 12,
        alignItems: 'center',
        alignSelf: 'flex-start',
        maxWidth: 200,
        ...(Platform.OS === 'web' && {
            cursor: 'pointer',
            transition: 'background-color 0.2s, border-color 0.2s',
            ':hover': {
                backgroundColor: colors.border,
                borderColor: colors.cookieBarGray,
            },
        }),
    },
    slimButtonText: {
        color: colors.darkGreen,
        fontSize: 15,
        fontWeight: '600',
    },
});
